import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.SubmissionFieldStars';

export default function SubmissionFieldStars({ context, question, value }) {
  return (
    <div className={styles.stars} data-value={`Stars: ${value}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className={cx(styles.star, { [styles.filled]: value >= i })}
          title={`${i} Star${i > 1 && 's'}`}
        ></div>
      ))}
    </div>
  );
}

SubmissionFieldStars.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
};
